import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import {Observable} from "rxjs";
import {ScheduleIngestConfig} from "../../models/scheduleIngestConfig";
import {BuySchedule} from "../../models/buySchedule";

export class ScheduleIngestConfigDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.SCHEDULE_INGEST_CONFIG, apiHelper);
    }

    public updateById(id: string, updates: Object): Observable<ScheduleIngestConfig> {
        const url = this.apiHelper.getServiceName() + this.getResource() + `/${id}`;
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'PUT', null, updates, headers);
    }

    public find(search: Object): Observable<ScheduleIngestConfig[]> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/find';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, search, headers);
    }
}